import React, { Fragment, Component} from 'react';
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux';
import {
    Button,
    Card,
    CardContent,
    FormControl,
    FormHelperText,
    InputLabel,
    OutlinedInput
} from '@material-ui/core';
import {Link} from "react-router-dom";
import {
    resetPasswordForm,
    toggleChangePassword
} from '../../../vendors/actions/layout';
import {
    changePasswordForm as changePasswordAction,
    changePassword
} from '../../../vendors/actions/user';
import {
    ChangePasswordSerializer
} from '../../../vendors/utils/serializers';
import {PencilIcon} from "../../../elements/svgIcons";
import PasswordInfoWindow from "../../../elements/passwordInfoWindow";
import {isMobileBrowser} from "../../../vendors/utils/common";


interface OwnProps {
    toggleChangePassword?: any
}

interface ConnectStateProps {
    Layout: any,
    ChangePasswordForm: any,
}

interface ConnectDispatchProps {
    toggleChangePassword: () => void,
    resetPasswordForm: () => void,
    changePassword: (data: any) => void,
    changePasswordAction: (data: any) => void,
}

interface MainState {
    showTooltip: boolean
}

type HeaderProps = OwnProps & ConnectStateProps & ConnectDispatchProps

 class ChangePassword extends Component<HeaderProps, MainState> {

    state = {
        showTooltip: false
    };

    componentWillUnmount(): void {
        this.props.Layout.editPassword && this.props.toggleChangePassword();
        this.props.resetPasswordForm()
    }

     setShowTooltip = () => {
        this.setState({showTooltip: true})
    };

     setParams = (e: any, field: string, validate: boolean = false) => {
        const value = e.target.value;
        if (e.target.classList.contains('MuiIconButton-edgeEnd')) return;
        this.props.changePasswordAction({value, field, validate});
    };

     reject = () => {
        this.props.toggleChangePassword();
        this.props.resetPasswordForm()
    };

     submit = () => {
        if (!this.props.ChangePasswordForm.valid) {
            for (const key in this.props.ChangePasswordForm.data) {
                const value = this.props.ChangePasswordForm.data[key].value;
                this.props.changePasswordAction({value, field: key, validate: true});
            }
            return;
        }
        const data = ChangePasswordSerializer(this.props.ChangePasswordForm.data);
        this.props.changePassword(data);
    };

     passwordCircles = () => {
        const arr = [];
        for (let i = 0; i < 10; i++) {
            arr.push(<span key={i} className="circle-blueprint circle"/>)
        }
        return arr;
    };

    render() {
        const {Layout, ChangePasswordForm} = this.props,
            {editPassword} = Layout,
            form = ChangePasswordForm.data;

        return (<Fragment>
            <Card className="card-box px-3 px-sm-4 pt-3 pb-2 pb-sm-0 overflow-visible">
                <div className="password-info rounded border-0">
                    <span className='heading'>Password</span>
                    {!editPassword && <PencilIcon className='password-edit' onClick={this.props.toggleChangePassword}/>}
                    {!editPassword && <div className='mt-4'>
                        {this.passwordCircles()}
                    </div>}
                </div>
                <CardContent className="p-2 px-sm-0 pt-sm-4">
                    {
                        editPassword && <div>
                            <div className={'mb-1'}>
                                <FormControl
                                    fullWidth
                                    error={!!form?.oldPassword?.error}
                                    variant="outlined">
                                    <InputLabel htmlFor="oldPassword">Old Password</InputLabel>
                                    <OutlinedInput
                                        onBlur={(e) => this.setParams(e, 'oldPassword')}
                                        error={!!form?.oldPassword?.error}
                                        fullWidth
                                        id="oldPassword"
                                        type={'password'}
                                        labelWidth={90}
                                    />
                                    <FormHelperText
                                        error={!!form?.oldPassword?.error}>{form?.oldPassword?.error}</FormHelperText>

                                </FormControl>
                            </div>
                            <div className={'mb-3 font-size-secondary text-right'}>
                                <Link to={'/forgot-password'}>
                                    Forgot Password?
                                </Link>
                            </div>
                            <div className='text-field-custom-mb'>
                                <FormControl
                                    fullWidth
                                    error={!!form?.newPassword?.error && form?.newPassword?.dirty}
                                    onBlur={(e) => this.setParams(e, 'newPassword', true)}
                                    variant="outlined"
                                    className={"password-info-window"}>
                                    <InputLabel htmlFor="newPassword">New Password</InputLabel>
                                    {isMobileBrowser() && <PasswordInfoWindow options={{...form?.newPassword?.errTypes}}/>}
                                        <OutlinedInput
                                            fullWidth
                                            onChange={(e) => {this.setParams(e, 'newPassword'); this.setShowTooltip()}}
                                            error={!!form?.newPassword?.error}
                                            id="newPassword"
                                            type={'password'}
                                            labelWidth={100}
                                        />
                                    {!isMobileBrowser() && <PasswordInfoWindow options={{...form?.newPassword?.errTypes}}/>}
                                    {!!form?.newPassword?.error && form?.newPassword?.dirty && <FormHelperText
                                        error={!!form?.newPassword?.error}>{form?.newPassword?.error}</FormHelperText>}
                                </FormControl>
                            </div>
                            <div className='text-field-custom-mb'>
                                <FormControl
                                    fullWidth
                                    error={!!form?.confirmPassword?.error && form?.confirmPassword?.dirty}
                                    onBlur={(e) => this.setParams(e, 'confirmPassword', true)}
                                    variant="outlined"
                                    className={"password-info-window"}>
                                    <InputLabel htmlFor="confirmPassword">Confirm Password</InputLabel>
                                    <OutlinedInput
                                        fullWidth
                                        onChange={(e) => this.setParams(e, 'confirmPassword')}
                                        error={!!form?.confirmPassword?.error && form?.confirmPassword?.dirty}
                                        id="confirmPassword"
                                        type={'password'}
                                        labelWidth={120}
                                    />
                                    {!!form?.confirmPassword?.error && form?.confirmPassword?.dirty && <FormHelperText
                                        error={!!form?.confirmPassword?.error}>{form?.confirmPassword?.error}</FormHelperText>}
                                </FormControl>
                            </div>
                            <div className='text-center text-sm-right my-4'>
                                <Button
                                    onClick={(e) => this.submit()}
                                    size={'small'}
                                    color="secondary"
                                    variant="contained"
                                    className="text-white mr-3">
                                    Save Changes
                                </Button>
                                <Button
                                    onMouseDown={(e) => this.reject()}
                                    size={'small'}
                                    color="secondary"
                                    variant="outlined"
                                    className="text-purple">
                                    Never Mind
                                </Button>
                            </div>
                        </div>
                    }
                </CardContent>
            </Card>
        </Fragment>)
    }
};

type ConnectStateMapper = MapStateToProps<ConnectStateProps, OwnProps>

const mapStateToProps: ConnectStateMapper = (state: any) => {
    const {Layout, ChangePasswordForm} = state;
    return {
        Layout,
        ChangePasswordForm
    }
};

type ConnectDispatchMapper = MapDispatchToProps<ConnectDispatchProps, OwnProps>

const mapDispatchToProps: ConnectDispatchMapper = (dispatch: any) => {
    return {
        toggleChangePassword: () => dispatch(toggleChangePassword()),
        resetPasswordForm: () => dispatch(resetPasswordForm()),
        changePasswordAction: (data: any) => dispatch(changePasswordAction(data)),
        changePassword: (data: any) => dispatch(changePassword(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);


